import AnimatedSection from '../common/AnimatedSection'
import { leadershipExpertiseIcons } from '../icons/LeadershipExpertiseIcons'
import LeadershipSectionLabel from '../leadership/LeadershipSectionLabel'
import { leadershipExpertise, leadershipExpertiseSection } from '../../data/leadershipPageData'

function LeadershipExpertise() {
  const { label, titleLine1, titleAccent } = leadershipExpertiseSection

  return (
    <AnimatedSection className="leadership-expertise">
      <div className="container corp-container">
        <header className="leadership-expertise__head">
          <LeadershipSectionLabel variant="red">{label}</LeadershipSectionLabel>
          <h2>
            {titleLine1} <span>{titleAccent}</span>
          </h2>
        </header>

        <div className="leadership-expertise__grid" role="list">
          {leadershipExpertise.map((item) => {
            const Icon = leadershipExpertiseIcons[item.icon]
            return (
              <article className="leadership-expertise__card" key={item.title} role="listitem">
                <div className="leadership-expertise__icon-wrap">
                  <span className="leadership-expertise__icon" aria-hidden="true">
                    <Icon />
                  </span>
                </div>
                <h3>{item.title}</h3>
              </article>
            )
          })}
        </div>
      </div>
    </AnimatedSection>
  )
}

export default LeadershipExpertise
